module.exports = __webpack_public_path__ + "img/chevron-left-blue.15c8fa51.svg";